<template>
  <v-navigation-drawer
    class="web-drawer"
    color="#24324b"
    fixed
    right
    width="320"
    overlay-color="#24324b"
    overlay-opacity=".55"
    temporary
    v-bind="$attrs"
    v-on="$listeners"
  >
    <nav class="web-drawer__inner" aria-label="Menu">
      <div class="web-drawer__head">
        <img src="@/assets/logo_white.svg" alt="SEEB Uberlândia" class="web-drawer__logo" />
        <button type="button" class="web-drawer__close" aria-label="Fechar menu" @click="close">
          <span aria-hidden="true"></span>
        </button>
      </div>

      <ul class="web-drawer__list">
        <li v-for="item in items" :key="item.name">
          <router-link
            :to="{ name: item.name }"
            :exact="item.name === 'Home'"
            class="web-drawer__link"
            active-class="is-active"
            @click.native="close"
          >
            {{ item.label }}
          </router-link>
        </li>
      </ul>

      <div class="web-drawer__actions">
        <router-link :to="{ name: 'Seja sócio' }" class="btn btn--primary" @click.native="close">
          Seja sócio
        </router-link>
        <a
          href="http://carteira.bancariosuberlandia.org.br"
          target="_blank"
          rel="noopener"
          class="btn btn--on-dark web-drawer__carteira"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <rect x="3" y="5" width="18" height="14" rx="2" />
            <circle cx="9" cy="11" r="2" />
            <path d="M6.5 16c.6-1.2 1.6-1.8 2.5-1.8s1.9.6 2.5 1.8M14 10h4M14 13.5h3" />
          </svg>
          Minha carteirinha
        </a>
      </div>

      <p class="web-drawer__contact">
        <a href="https://wa.me/553432367277" target="_blank" rel="noopener" class="web-drawer__whats">
          <img src="@/assets/logo-whatsapp.png" alt="" width="18" height="18" />
          (34) 3236 7277
        </a>
        <span>R. Duque de Caxias, 95, Centro, Uberlândia - MG</span>
      </p>
    </nav>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "Drawer",

  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    close() {
      this.$emit("input", false);
    },
  },
};
</script>

<style lang="scss">
.web .web-drawer {
  z-index: 7 !important;
  font-family: var(--font-text);

  &__inner {
    display: flex;
    flex-direction: column;
    min-height: 100%;
    padding: 0 24px 32px;
  }

  &__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 72px;
    margin-bottom: 8px;
    border-bottom: 1px solid var(--c-line-dark);
  }

  &__logo {
    height: 38px;
    width: auto;
  }

  &__close {
    position: relative;
    width: 44px;
    height: 44px;
    margin-right: -10px;
    background: none;
    border: 0;
    cursor: pointer;

    span::before,
    span::after {
      content: "";
      position: absolute;
      left: 11px;
      right: 11px;
      top: 21px;
      height: 2px;
      background: #fff;
      border-radius: 2px;
    }

    span::before {
      transform: rotate(45deg);
    }

    span::after {
      transform: rotate(-45deg);
    }
  }

  &__list {
    list-style: none;
    margin: 0;
    padding: 8px 0;
  }

  .web-drawer__link {
    display: flex;
    align-items: center;
    min-height: 52px;
    color: var(--c-on-dark);
    font-family: var(--font-display);
    font-size: 24px;
    font-weight: 500;
    text-decoration: none;
    border-bottom: 1px solid var(--c-line-dark);

    &:hover {
      color: #fff;
    }

    &.is-active {
      color: #fff;
      text-decoration: underline;
      text-decoration-color: var(--c-orange);
      text-decoration-thickness: 2px;
      text-underline-offset: 8px;
    }
  }

  &__actions {
    display: grid;
    gap: 12px;
    margin-top: 28px;
  }

  &__contact {
    display: grid;
    gap: 4px;
    margin: auto 0 0;
    padding-top: 32px;
    color: var(--c-on-dark);
    font-size: var(--fs-meta);
    line-height: 1.5;

    a {
      color: #fff;
      font-size: 16px;
      font-weight: 600;
      text-decoration: none;
    }

    .web-drawer__whats {
      display: inline-flex;
      align-items: center;
      gap: 10px;
    }

    .web-drawer__whats img {
      display: block;
      width: 18px;
      height: 18px;
      filter: brightness(0) invert(1);
    }
  }
}

.web .web-drawer__carteira {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.web .web-drawer__carteira svg {
  width: 20px;
  height: 20px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}
</style>
